import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { setupTooltip } from "./tooltip";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate({
		onCompleted: () => {
			setupTooltip();
		},
	});
});
